<div class="initial-occupancy-wrapper">
    <header class="top-header">
        <h3>Initial Occupancy Upload</h3>
        <p>System initialization tool for go-live occupancy seeding. Super User access only.</p>
    </header>

    <div class="upload-form-card">
        <div class="form-field">
            <label for="organization">Organization <span class="required">*</span></label>
            <select
                    id="organization"
                    name="organization"
                    [(ngModel)]="selectedOrganizationId"
                    [disabled]="loadingOrganizations">
                <option [ngValue]="null" disabled>Select organization</option>
                <option *ngFor="let org of organizations" [ngValue]="org.id">{{ org.name }}</option>
            </select>
        </div>

        <div class="form-field">
            <label>Upload File <span class="required">*</span></label>
            <div class="file-row">
                <button type="button" class="btn-action" (click)="fileInput.click()"
                        [disabled]="uploading || validating">
                    <fa-icon [icon]="['fas', 'upload']"></fa-icon>
                    Choose File
                </button>
                <span class="file-name">{{ selectedFileName || 'No file selected' }}</span>
                <input #fileInput type="file" accept=".csv,.xlsx" (change)="onFileSelected($event)" hidden/>
            </div>
        </div>

        <div class="form-actions">
            <button type="button" class="btn-action" (click)="downloadTemplate()">
                <fa-icon [icon]="['fas', 'file-excel']"></fa-icon>
                Download Template
            </button>
            <button type="button" class="btn-action" (click)="beginUpload()" [disabled]="!canSubmit">
                <fa-icon [icon]="['fas', 'upload']"></fa-icon>
                {{ validating ? 'Validating...' : (uploading ? 'Uploading...' : 'Upload') }}
            </button>
        </div>
    </div>

    <div *ngIf="successSummary" class="success-summary">
        <h4>Import Summary</h4>
        <p><strong>Organization:</strong> {{ successSummary.organizationName }}</p>
        <p><strong>Vehicles Created:</strong> {{ successSummary.vehiclesCreated }}</p>
        <p><strong>Initial Occupancy Logs Created:</strong> {{ successSummary.initialOccupancyLogsCreated }}</p>
    </div>

    <app-bulk-import-result
            *ngIf="bulkImportResult"
            [totalImported]="bulkImportResult.totalImported"
            [totalFailed]="bulkImportResult.totalFailed"
            [errors]="bulkImportResult.errors"
            [failedRowsCsvBase64]="bulkImportResult.failedRowsCsvBase64"
            [failedRowsFilename]="bulkImportResult.failedRowsFilename">
    </app-bulk-import-result>
</div>

<div *ngIf="showConfirmationModal" class="confirmation-modal">
    <div class="modal-content">
        <div class="modal-header">
            <h3>Confirm Initial Occupancy Upload</h3>
        </div>
        <div class="modal-body confirmation-body">
            <p><strong>Organization:</strong> {{ pendingOrganizationName }}</p>
            <p><strong>Records Found:</strong> {{ pendingRecordCount }}</p>
            <p>This action will:</p>
            <ul>
                <li>Create {{ pendingRecordCount }} Vehicles</li>
                <li>Create {{ pendingRecordCount }} Initial Occupancy Logs</li>
                <li>Increase Occupancy Counts</li>
            </ul>
            <p>Are you sure you want to continue?</p>
        </div>
        <div class="modal-footer">
            <button type="button" class="cancel-btn cancel-btn-green" (click)="cancelConfirmation()">Cancel</button>
            <button type="button" class="confirm-btn modal-red" (click)="confirmUpload()">Proceed</button>
        </div>
    </div>
</div>
